import { render, staticRenderFns } from "./estalagem.vue?vue&type=template&id=100690c0&scoped=true&"
import script from "./estalagem.vue?vue&type=script&lang=js&"
export * from "./estalagem.vue?vue&type=script&lang=js&"
import style0 from "./estalagem.vue?vue&type=style&index=0&id=100690c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100690c0",
  null
  
)

export default component.exports